module.exports = __webpack_public_path__ + "static/8011365485db2f04b9001c-37bfe00842e01b58a328b23e40098919.jpg";